<template>
  <div v-if="!active" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
    <v-card style="padding: 15px; width: 350px; position: relative;">
      <v-icon
        class="ma-1"
        style="position: absolute; top: 5px; right: 5px;"
        color="#0D47A1"
        large
        @click="$router.push({ name: 'Inicio' })"
      >
        mdi-close-circle
      </v-icon>

      <div class="text-center">
        <v-img width="150" :src="$appInfo.icon" class="mx-auto mb-2" />

        <!-- Campo de contraseña -->
        <v-text-field
          v-model="clave"
          label="Contraseña"
          type="password"
          outlined
          dense
          class="mt-2"
          style="font-size: xx-large;"
        ></v-text-field>

        <!-- Botón -->
        <v-btn block color="#11476b" style="color: white;" class="mt-2 pa-7" @click="validar()">
          <h1>ACCEDER</h1>
        </v-btn>
      </div>
    </v-card>
  </div>
  <v-app v-else>
    <div>
      <!-- Sidebar -->
      <v-icon @click="showMenu = !showMenu" class="pa-2" style="position: fixed; z-index: 99;" large>mdi-menu</v-icon>
      <v-navigation-drawer v-if="showMenu" app permanent width="150" class="blue lighten-5">
        <br>
        <br>
        <v-list dense style="padding-top: 20px;">
          <v-list-item-group>
            <v-list-item :style="!itemMenu.habilitado ? { opacity: '0.5' } : {}" v-for="itemMenu in menuItems"
              :key="'itemMenu' & itemMenu.tag" @click="itemMenu.habilitado ? seccion = itemMenu.tag : null">
              <v-list-item-icon class="mr-3"><v-icon>{{ itemMenu.icon }}</v-icon></v-list-item-icon>
              <v-list-item-content>
                <h3>{{ itemMenu.tag }}</h3>
              </v-list-item-content>
            </v-list-item>
            <br>
            <br>
            <hr>
            <v-list-item @click="$router.push({ path: '/' })">
              <v-list-item-icon class="mr-3"><v-icon>mdi-page-previous</v-icon></v-list-item-icon>
              <v-list-item-content>
                <h3>Cerrar</h3>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <!-- Main content -->
      <v-main>
        <v-container fluid>
          <v-icon class="ma-1 right top" style="position: absolute" color="#0D47A1" large
            @click="$router.push({ path: '/' })">mdi-close-circle</v-icon>

          <div class="center">
            <instituto v-if="seccion == 'Instituto'" />
            <noticias v-if="seccion == 'Noticias'" />
            <cursos v-if="seccion == 'Cursos'" />
            <solicitudes v-if="seccion == 'Solicitudes'" />
            <estudiantes v-if="seccion == 'Estudiantes'" />
            <docentes v-if="seccion == 'Docentes'" />
            <instructores v-if="seccion == 'Instructores'" />
            <libros v-if="seccion == 'Libros'" />
            <popup v-if="seccion == 'Popup'" />
            <ajustes v-if="seccion == 'Ajustes'" />
          </div>
        </v-container>
      </v-main>
    </div>
  </v-app>
</template>

<script>
import instituto from "@/components/dashboard/instituto/instituto";
import noticias from "@/components/dashboard/noticias/noticias";
import cursos from "@/components/dashboard/cursos/cursos";
import libros from "@/components/dashboard/libros/libros";
import solicitudes from "@/components/dashboard/solicitudes/solicitudes";
import estudiantes from "@/components/dashboard/estudiantes";
import docentes from "@/components/dashboard/docentes";
import instructores from "@/components/dashboard/instructores/instructores";
import popup from "@/components/dashboard/popups/popups";
import ajustes from "@/components/dashboard/ajustes/ajustes";
export default {
  components: {
    instituto,
    noticias,
    cursos,
    libros,
    solicitudes,
    estudiantes,
    instructores,
    docentes,
    popup,
    ajustes,
  },
  data() {
    return {
      clave:'',
      claveAdmin:'@Insegt#3432Melon',
      active:false,
      seccion: 'Instituto',
      showMenu: true,
      menuItems: [
        { tag: "Instituto", icon: "mdi-domain", habilitado: true },
        { tag: "Noticias", icon: "mdi-newspaper", habilitado: true },
        { tag: "Cursos", icon: "mdi-school", habilitado: true },
        { tag: "Solicitudes", icon: "mdi-account", habilitado: true },
        { tag: "Estudiantes", icon: "mdi-account-multiple", habilitado: false },
        { tag: "Docentes", icon: "mdi-teach", habilitado: false },
        { tag: "Instructores", icon: "mdi-shield", habilitado: true },
        { tag: "Libros", icon: "mdi-library", habilitado: true },
        { tag: "Popup", icon: "mdi-alert-circle-outline", habilitado: true },
        { tag: "Ajustes", icon: "mdi-wrench", habilitado: true }
      ],

    };
  },
  mounted() {

  },
  created() {

  },
  methods: {
validar(){
  if (this.clave===this.claveAdmin) {
    this.active=true
  }
}

  },
  computed: {
  },
  beforeDestroy() {
  },
};
</script>

<style scoped>
.centered-input>>>input {
  text-align: center;
}
</style>